import CashPaymentForm from "./CashPaymentForm"
import PropTypes from "prop-types"
import CustomDrawer from "ui/Drawer"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import { Modal } from "ui/Modal"
import { useState } from "react"
import { UnsavedChangesModal } from "ui/UnsavedChangesModal"

const RecordPaymentModal = ({ onOpen, onClose, remainingBalance, bookingUUID, bookingId }) => {
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm", "md"].includes(breakpoint)
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)

  const requestClose = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedModal(true)
      return
    }
    executeClose()
  }

  const executeClose = () => {
    setShowUnsavedModal(false)
    onClose()
  }

  const modalContent = (
    <CashPaymentForm
      remainingBalance={remainingBalance}
      bookingUUID={bookingUUID}
      bookingId={bookingId}
      onClose={requestClose}
      onSubmitClose={executeClose}
      onUnsavedChangesChange={setHasUnsavedChanges}
    />
  )

  return (
    <>
      {isMobile ? (
        <CustomDrawer open={onOpen} setOpen={requestClose} title="Record Payment">
          {modalContent}
        </CustomDrawer>
      ) : (
        <Modal centered title="Record Payment" open={onOpen} onCancel={requestClose} width={800}>
          {modalContent}
        </Modal>
      )}
      <UnsavedChangesModal
        open={showUnsavedModal}
        onDiscard={executeClose}
        onKeepEditing={() => setShowUnsavedModal(false)}
        zIndex={1200}
      />
    </>
  )
}

RecordPaymentModal.propTypes = {
  onOpen: PropTypes.bool,
  onClose: PropTypes.func,
  remainingBalance: PropTypes.number,
  bookingUUID: PropTypes.string,
  bookingId: PropTypes.number
}

export default RecordPaymentModal
